import * as api from '../api';


const CACHE_DURATION = 30000;   // Cache the user status for 30 seconds
let pendingPromise = null;      // Store the in-progress promise

export const UserStatus = (history) => {
    const currentTime = Date.now();

    // Retrieve cached data and timestamp from localStorage
    const cachedData = JSON.parse(sessionStorage.getItem('userStatusCache'));
    const lastCallTime = parseInt(sessionStorage.getItem('lastUserStatusCallTime'), 10) || 0;

    // Check if we have valid cache data within the CACHE_DURATION
    if (cachedData && currentTime - lastCallTime < CACHE_DURATION) {
        return Promise.resolve(cachedData);
    }

    // If there's a pending request, return it to reuse the same promise
    if (pendingPromise) {
        return pendingPromise;
    }

    // Otherwise, initiate a new API call and cache it
    pendingPromise = new Promise((resolve, reject) => {
        api
            .get('/user/status')
            .then(response => {
                const { authenticated, access_token, customer_onboarding } = response.data.data;

                if (authenticated) {
                    // Retrieve and parse local storage data
                    const localData = JSON.parse(sessionStorage.getItem('authentication')) || {};

                    // Update access token if it has changed
                    if (localData.access_token !== access_token) {
                        localData.access_token = access_token;
                        localData.customer_onboarding = customer_onboarding;

                        // Update both local and session storage
                        // localStorage.setItem('authentication', JSON.stringify(localData));
                        sessionStorage.setItem('authentication', JSON.stringify(localData));
                    }
                }

                // Cache the response and update the last call time in localStorage
                sessionStorage.setItem('userStatusCache', JSON.stringify(response.data));
                sessionStorage.setItem('lastUserStatusCallTime', currentTime.toString());

                // Resolve the pending promise and reset it after completion
                resolve(response.data);
            })
            .catch(error => {
                // api.apiErrorHandler(error, history);
                reject(error);
            })
            .finally(() => {
                pendingPromise = null; // Reset pendingPromise after completion
            });
    });

    return pendingPromise;
};

export const UserSignout = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/user/sign_out', data)
            .then(response => {
                // remove also the localstorage items
                localStorage.removeItem("authentication");
                localStorage.removeItem("last_url");
                sessionStorage.removeItem("authentication");
                sessionStorage.removeItem('userStatusCache');
                sessionStorage.removeItem('lastUserStatusCallTime');
                resolve(response.data);
            })
            .catch(error => {
                // api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

// export const UserSignout = (data) => {
//     return new Promise((resolve, reject) => {
//         api
//             .post('/user/sign_out', data)
//             .then(response => {
//                 resolve(response.data);
//                 // remove also the localstorage items
//                 sessionStorage.removeItem("authentication");
//             })
//             .catch(error => {
//                 // console.error('error: ', error);
//                 reject(error);
//             })
//     });
// };

// export const UserStatus = (data) => {
//     const location = data.location.split("/");
//     let new_location;


//     if (location.length > 3) {
//         new_location = location[1] + '_' + location[3];
//     } else {
//         new_location = data.location.substring(1).replace("/", "_");
//     }

//     return new Promise((resolve, reject) => {
//         api
//             .get('/user/status/' + new_location)
//             .then(response => {
//                 resolve(response.data);
//             })
//             .catch(error => {
//                 console.error('error: ', error);
//                 reject(error);
//             })
//     });
// };

export const UserLogin = (data) => {
    return new Promise((resolve, reject) => {
        api
            .post('/user/login', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                // console.error('error: ', error);
                reject(error);
            })
    });
};

export const RequestPassword = (data) => {
    return new Promise((resolve, reject) => {
        api
            .post('/user/request_password', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const ConfirmRequestPassword = (data) => {
    return new Promise((resolve, reject) => {
        api
            .post('/user/confirm_request_password', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const ChangePassword = (data) => {
    return new Promise((resolve, reject) => {
        api
            .put('/user/changepassword', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const ChangePasswordForced = (data) => {
    return new Promise((resolve, reject) => {
        api
            .put('/user/changepassword_forced', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const UserUpdate = (data) => {
    return new Promise((resolve, reject) => {
        api
            .put('/user/update', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const UserDelete = (data) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/user/delete', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const UserAdd = (data) => {
    return new Promise((resolve, reject) => {
        api
            .post('/user/add', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const RegisterCustomer = (data) => {
    return new Promise((resolve, reject) => {
        api
            .post('/registration/new', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const AccountActivateService = (data) => {
    return new Promise((resolve, reject) => {
        api
            .post('/registration/activate', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const CheckUserExists = (data) => {
    return new Promise((resolve, reject) => {
        api
            .post('/user/user_exists', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const AccountActivationStatus = (validation_token) => {
    return new Promise((resolve, reject) => {
        api
            .get('/registration/registration_status/' + validation_token)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const UserDetails = (data) => {
    return new Promise((resolve, reject) => {
        api
            .get('/user/details/' + data.user_id)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const UserList = (customer_id) => {
    return new Promise((resolve, reject) => {
        api
            .get('/user/list/' + customer_id)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const GetUserMFAToken = () => {
    return new Promise((resolve, reject) => {
        api
            .get('/user/mfa/generate_mfa_code')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const ListInviteCodes = (customer_id) => {
    return new Promise((resolve, reject) => {
        api
            .get('/user/list_invite_codes/' + customer_id)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};


export const CheckInviteCode = (code) => {
    return new Promise((resolve, reject) => {
        api
            .get('/user/check_invite_code/' + code)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};


export const GenerateInviteCodes = (data) => {
    return new Promise((resolve, reject) => {
        api
            .post('/user/generate_invite_codes', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};


export const EnableUserMFA = (data) => {
    return new Promise((resolve, reject) => {
        api
            .put('/user/mfa/enable', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const DisableUserMFA = (data) => {
    return new Promise((resolve, reject) => {
        api
            .put('/user/mfa/disable', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};


export const GetCustomerUsergroups = (customer_id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/user/customer_usergroup_list/${customer_id}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const ImpersonateCustomer = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post(`/user/impersonate_customer`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const DeleteUserIPLocation = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/user/user_ip_location', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetUsergroups = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/user/usergroup_list')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const AddUsergroup = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/user/add_usergroup', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const EditUsergroup = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/user/usergroup', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const DeleteUsergroup = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/user/usergroup', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const GetUsergroupResources = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/user/resource_list')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const UserMagicLink = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/user/get_magic_link', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CheckMagicLink = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/user/check_magic_link', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CheckLocationValidationLink = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/user/check_location_validation', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};